<template>
  <div>
    <nav-breadcrumb :menu="[{ label:'导入银行流水'}]"/>

    <el-row>
      <el-col>
        <panel label="">
          <el-form :model="bankForm" :rules="bankFormRules" ref="bankForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="12">
                <el-form-item label="选择银行：" prop="t__bankCode" :rules="{required: true, message: '银行不能为空'}">
                  <el-select placeholder="请选择" v-model.trim="bankForm.t__bankCode" >
                    <el-option value="CIB" label="兴业银行"></el-option>
                    <el-option value="CMB" label="招商银行"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </panel>
        <panel title="">
          <files-upload :file-list.sync="fileList" :max="1" :allow-file-ext="['Excel']"></files-upload>
        </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
        <el-button type="primary" @click="onSubmit('bankForm')">确认提交</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import FilesUpload from '../../components/FilesUpload'
    export default {
        name: "ImportBankTally",
      data(){
        return {
          bankForm:{
            t__bankCode: 'CIB'
          },
          bankFormFiles: [],
          files:{},
          deviceTypeOptions : [],

          disabledOptions:[
            {
              label:'中国工商银行',
              value:'中国工商银行'
            },
            {
              label:'中国农业银行',
              value:'中国农业银行'
            },
          ],
          bankFormRules: {},
        }
      },
      components: {
        FilesUpload,
      },
      computed:{
        fileList: {
          get() {
            return this.bankFormFiles
          },
          set(newVal) {
            this.bankFormFiles = newVal.map(item => Object.assign(item, {
                't__fileId': item.fileId,
                't__checked': true
              })
            )
          }
        }
      },
      mounted() {
       /* if(this.dealerId){
          this.getData()
        }*/
       // this.getdealerType()
      },
      methods:{
        getData:function(){
          xhr.getDealer({
              'd.dealerId': this.dealerId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.dealerForm = res.data.data
                }
              }catch (e) {

              }
            })
        },

        onSubmit: function (formName) {
          let bankForm = this.bankForm
          if(this.bankFormFiles.length!=1){
            this.$message({
              type: 'error',
              message: '上传文件不能为空'
            })
          }
          this.$refs[formName].validate(valid=> {
            if (valid) {
              bankForm.t__checked = true
              bankForm.fileId = this.bankFormFiles[0].t__fileId
              xhr.uploadBankStatement(bankForm, res=> {
                try {
                  if (res.data.status == 'success') {

                   /* this.$router.push({
                      name: 'ImportBankTallyLogList'
                    })*/
                  }
                } catch (e) {
                }
              })
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ImportBankTally.vue